import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';

const CartTotal = (props) => {

    let cartItemCount = 0;
    let cartItemTotal = 0;
    let cart = localStorage.getItem('cartData');
    let cartData = JSON.parse(cart);
    //console.log(cart);
    //console.log(cartData);
    if(cart !== null && cart!=='{}')
    {
        Object.keys(cartData).forEach(function(key) {
            let Rate = 0;
            let itemTOTAL = 0;

            let cart_id = key.split('~~**~~');
            let itemID = cart_id[0];
            let itemCOUNT = cartData[key];
            let itemCUSTOM = cart_id[1];

            props.items.map(item=>{
                if(item.ITEMID==itemID)
                {
                    Rate = item.RATE;
                }
            })

            if(itemCUSTOM!='N')
            {
                let custom = itemCUSTOM.split('|');
                //console.log(custom);
                if(custom!='')
                {
                    custom.forEach(val => { 
                        let val2 = val.split('~');
                        Rate = parseFloat(Rate) + parseFloat(val2[3]);
                        //console.log(Rate);
                    });
                }
            }


            itemTOTAL = itemCOUNT * Rate;

            cartItemCount = cartItemCount + itemCOUNT;
            cartItemTotal = cartItemTotal + itemTOTAL;
        });    
    }

    return (
        <div className="row" style={{width: '100%'}}>
            <div className="col-6">
                <div className="section-title">TOTAL</div>
            </div>
            <div className="col-6">
                <div className="red" style={{textAlign: 'right'}}>&#8377; {cartItemTotal}</div>
            </div>
        </div>
    );
}
  
export default CartTotal;


// WEBPACK FOOTER //
// ./src/components/CartTotal.js